import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link} from "@reach/router";
import FlickitySlider from "./FlickitySlider";

class HomeSliderItem extends Component{
  render(){
    let videos = [];
    this.props.data.items.forEach((item, index) => {
      videos.push(
          <div className="carousel-cell" key={'vid' + index}>
            <Link to={item.url}>
              <div className="slider-img">
                <img src={item.image} />
                {item.playicon &&
                <img className="btn-play-video" src="https://app.triyakom.com/artist_portal/old/btn-play-video.svg"/>
                }
              </div>
              <div className="slider-text"><div>{item.title}</div></div>
            </Link>
          </div>
      );
    });
    return(
      <>
      <div className="hsc-list">
        <div className="container">
          <h4>{this.props.data.title}</h4>
        </div>
        <FlickitySlider options={{ "freeScroll": true, "contain": true, "prevNextButtons": false, "pageDots": false }}>
          {videos}
          <div className="div-last-slider"></div>
        </FlickitySlider>
      </div>
      </>
    );
  }
}

export default HomeSliderItem;
